// extracted by mini-css-extract-plugin
export var backdropBlur = "_lb-0";
export var contentCard = "_lb-5";
export var frame = "_lb-2";
export var image = "_lb-4";
export var imagePane = "_lb-3";
export var modal = "_lb-1";